// extracted by mini-css-extract-plugin
export default {"container":"ListAttr_container__RBoMC","wrapper-attr":"ListAttr_wrapper-attr__N0daE","attr":"ListAttr_attr__u5pjc","value":"ListAttr_value__EuUBf"};